import React from "react";

export default function SearchingGame() {
  return (
    <div
      style={{
        position: "absolute",
        top: "calc(50%)",
        left: 0,
        margin: 0,
        width: "100%",
        textAlign: "center"
      }}
    >
      <div>Searching if playing game...</div>
    </div>
  );
}
